document.addEventListener('alpine:init', () => {
    /**
     * Set css var x, y, w, h for $el's rendered position and dimensions
     * relative to the document. $el is always the tracked source - the
     * variables are written onto $el itself unless a selector is given, in
     * which case they're written onto that target element instead.
     */
    Alpine.directive('page-pos', ($el, { expression: selector }) => {
        const $target = selector ? document.querySelector(selector) : $el
        if (!$target) return

        const getPagePos = (node) => {
            let x = 0, y = 0
            while (node) {
                x += node.offsetLeft
                y += node.offsetTop
                node = node.offsetParent
            }
            return { x, y }
        }

        const update = () => {
            $target.style.setProperty('--x', `${getPagePos($el).x}px`)
            $target.style.setProperty('--y', `${getPagePos($el).y}px`)
            $target.style.setProperty('--w', `${$el.offsetWidth}px`)
            $target.style.setProperty('--h', `${$el.offsetHeight}px`)
        }

        // wait for layout (e.g. header height CSS vars from x-resize) to settle
        requestAnimationFrame(() => requestAnimationFrame(update))

        // `resize` only fires for viewport size changes, not for a DOM
        // mutation that changes the document's height (content added/
        // removed, an image loading in, an accordion expanding) - a
        // ResizeObserver on body catches both, since the viewport resizing
        // also changes body's own rendered box in virtually every layout.
        const resizeObserver = new ResizeObserver(update)
        resizeObserver.observe(document.body)

        // Manual escape hatch for the rare case something shifts this
        // element without changing body's overall rendered size at all.
        window.addEventListener('page-pos:update', update)

        return () => {
            resizeObserver.disconnect()
            window.removeEventListener('page-pos:update', update)
        }
    })

    /**
     * Clone $el into a target element (given as a selector) on init. Strips
     * this directive from the clone itself, since Alpine's own
     * MutationObserver picks up any directive-bearing node it sees inserted -
     * left in place, the clone would immediately clone itself too, forever.
     */
    Alpine.directive('clone', ($el, { expression: selector }) => {
        const $target = document.querySelector(selector)
        if (!$target) return

        const clone = $el.cloneNode(true)
        clone.removeAttribute('x-clone')
        $target.append(clone)

        // The clone is a brand new subtree - anything inside it that's
        // measured/initialized on first sight (e.g. btn-morph's shape divs)
        // never ran for it, so a plain resize won't make it react. Let
        // whatever cares about newly-inserted content re-check.
        clone.dispatchEvent(new CustomEvent('shape:rebuild', { bubbles: true }))
    })

    /**
     * Toggle `stuck` on a `position: sticky` element once it's actually
     * pinned at its sticky offset, rather than still sitting in normal flow.
     */
    Alpine.directive('stuck', ($el) => {
        const top = parseInt(getComputedStyle($el).top) || 0
        let frame

        const check = () => {
            $el.classList.toggle('stuck', Math.round($el.getBoundingClientRect().top) <= top)
            frame = requestAnimationFrame(check)
        }

        check()

        return () => cancelAnimationFrame(frame)
    })
})
